import { Link } from "react-router-dom";
import { genres } from "@/mocks/movies";

export default function GenreEntry() {
  return (
    <section className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
      <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <p className="font-label text-[11px] uppercase tracking-[0.24em] text-primary-600">
            Browse By Genre
          </p>
          <h2 className="mt-2 text-xl font-bold text-foreground-950 md:text-2xl">按类型找片</h2>
        </div>
        <p className="text-sm text-foreground-600">八个常见类型入口，点一下直达筛选结果</p>
      </div>

      <div className="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-4 lg:grid-cols-8">
        {genres.map((genre, index) => (
          <Link
            key={genre.name}
            to={`/category?type=${encodeURIComponent(genre.name)}`}
            className="group animate-fade-up flex flex-col items-start gap-3 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 hover:bg-primary-50"
            style={{ animationDelay: `${index * 40}ms` }}
          >
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-100 text-primary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
              <i className={`${genre.icon} text-base w-4 h-4 flex items-center justify-center`} />
            </span>
            <span>
              <span className="block text-sm font-medium text-foreground-950">{genre.name}</span>
              <span className="mt-0.5 block text-[11px] text-foreground-500">{genre.desc}</span>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}